module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AD7vx5/tc-custom/cover.jpg?1684514925423?1702528841104",
      "alt": "This image is the cover for the book Prohibition in South Dakota"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prohibition in South Dakota\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("South Dakota has always had an intermittent relationship with prohibition. Constantly changing legislation kept citizens, saloonkeepers, bootleggers and other scofflaws on tenterhooks, wondering what might come next. The scandalous indiscretions of the lethal Verne Miller and the contributions of \"agents of change\" like Senators Norbeck and Senn kept ne'er-do-wells on edge. In 1927, the double murder of prohibition officers near Redfield dominated headlines. From the Black Hills stills of Bert Miller to the Sioux Falls moonshine outfit buried under Lon Vaught's chicken house, uncork these oft-overlooked and tumultuous eighteen years in state history. In the first book of its kind, award-winning journalist Chuck Cecil delivers the boisterous details of an intoxicating era.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chuck Cecil\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Wessington Springs, Chuck Cecil has been a reporter, photographer, university administrator and editor/publisher of eleven weekly newspapers. Currently, he writes a prize-winning weekly column in the Brookings Register newspaper, has a short program on all of the Brookings radio stations and has written and published twenty-one books. His book on prohibition in South Dakota is the only one ever written about that eighteen-year experience.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0